import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, BookOpen, Drama, Landmark } from 'lucide-react';
export function PlanProfesionalBeneficios() {
  const negativos = ['Vocabulario general sin terminología técnica', 'Improvisás en situaciones profesionales reales', 'Sin simulaciones para practicar antes de enfrentarlas', 'Sin herramientas para implementar accesibilidad en tu institución'];
  const positivos = ['Glosario técnico de 290 señas por especialidad', '16 simulaciones reales para practicar antes de la situación', 'Kit institucional con protocolo, cartelería y marco legal', 'Acceso a futuras actualizaciones del vocabulario técnico'];
  const bonos = [{
    icon: BookOpen,
    label: 'Plan Profesional #1',
    emoji: '📖',
    title: 'Glosario Técnico por Especialidad',
    desc: 'Salud, Educación, Legal y Banca. 290 señas técnicas listas para usar en tu trabajo, organizadas por especialidad y nivel de urgencia.'
  }, {
    icon: Drama,
    label: 'Plan Profesional #2',
    emoji: '🎭',
    title: 'Guía de Rol y Simulaciones Profesionales',
    desc: '16 situaciones reales simuladas con diálogos completos. Practicás antes de enfrentarlo — no durante.'
  }, {
    icon: Landmark,
    label: 'Plan Profesional #3',
    emoji: '🏛️',
    title: 'Kit de Accesibilidad Institucional',
    desc: 'Protocolo de atención, cartelería lista para imprimir y marco legal argentino. Para llevar a tu institución y generar un cambio real.'
  }];
  return <section className="bg-lsa-dark text-white py-16 px-5 border-t border-white/10" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <div className="text-center mb-10" data-id="element-146">
          <h2 className="text-[26px] sm:text-[32px] font-extrabold leading-tight tracking-tight mb-3" data-id="element-147">
            Qué vas a obtener con el{' '}
            <span className="text-lsa-cyan" data-id="element-148">PLAN PROFESIONAL</span>
          </h2>
          <p className="text-white/60 text-[15px] max-w-md mx-auto" data-id="element-149">
            La diferencia entre aprender LSA y ser un profesional accesible
          </p>
        </div>

        {/* COMPARISON CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-16" data-id="element-150">
          {/* Negative */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0E1730]/50 border border-white/10 rounded-2xl p-6" data-id="element-151">
            <span className="inline-flex items-center gap-2 bg-white/5 text-white/60 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide mb-4" data-id="element-152">
              <X size={14} data-id="element-153" /> Si no tenés el Plan Profesional
            </span>
            <h3 className="font-bold text-[18px] mb-5 text-white/90" data-id="element-154">
              Solo tenés el sistema base
            </h3>
            <ul className="space-y-3" data-id="element-155">
              {negativos.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[14px] text-white/60" data-id="element-156">
                  <X className="text-red-400/80 shrink-0 mt-0.5" size={18} data-id="element-157" />
                  <span data-id="element-158">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Positive */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-[#0E1730] border-2 border-lsa-cyan rounded-2xl p-6 shadow-[0_0_24px_rgba(25,199,232,0.18)]" data-id="element-159">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 bg-lsa-cyan text-lsa-deep rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-160">
              👑 Recomendado
            </span>
            <span className="inline-flex items-center gap-2 bg-lsa-cyan/15 text-lsa-cyan rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide mb-4" data-id="element-161">
              <Check size={14} data-id="element-162" /> Si tenés el Plan Profesional
            </span>
            <h3 className="font-bold text-[18px] mb-5" data-id="element-163">
              Tenés un sistema profesional completo
            </h3>
            <ul className="space-y-3" data-id="element-164">
              {positivos.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[14px] text-white/90" data-id="element-165">
                  <Check className="text-lsa-cyan shrink-0 mt-0.5" size={18} data-id="element-166" />
                  <span data-id="element-167">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* EXCLUSIVE BONUSES */}
        <div className="text-center mb-8" data-id="element-168">
          <h3 className="text-[22px] sm:text-[26px] font-extrabold leading-tight mb-2" data-id="element-169">
            3 bonos exclusivos del Plan Profesional
          </h3>
          <p className="text-white/60 text-[15px]" data-id="element-170">
            Solo disponibles si elegís el Plan Profesional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-171">
          {bonos.map((bono, i) => {
          const Icon = bono.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#0E1730]/50 border border-white/10 rounded-2xl p-6" data-id="element-172">
                <div className="flex items-center gap-3 mb-4" data-id="element-173">
                  <div className="w-11 h-11 rounded-xl bg-lsa-cyan/15 flex items-center justify-center text-lsa-cyan shrink-0" data-id="element-174">
                    <Icon size={22} data-id="element-175" />
                  </div>
                  <span className="text-[12px] font-bold uppercase tracking-wide text-lsa-cyan" data-id="element-176">
                    {bono.label}
                  </span>
                </div>
                <h4 className="font-bold text-[17px] mb-3 leading-snug" data-id="element-177">
                  <span className="mr-1" data-id="element-178">{bono.emoji}</span>
                  {bono.title}
                </h4>
                <p className="text-[14px] text-white/65 leading-relaxed" data-id="element-179">
                  {bono.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}